module.exports = __webpack_public_path__ + "img/pride.9e278dba.svg";